var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var RotateModel = function () {
    lib_core.Model.apply(this);

    this.rotateAngle = 90;
};
lib_core.inherit(RotateModel, lib_core.Model);
lib_core.JsonParser.registerClass(RotateModel, "RotateModel");

module.exports = RotateModel;

RotateModel.prototype.rotateSelection = function(direction) {

    if (typeof direction === 'undefined') {
        direction = 1;
    }

    var angleDegrees = (direction >= 0) ? this.rotateAngle : -this.rotateAngle;

    var components =  new lib_core.Collections.HashSet();
    var set = new lib_geometry.PointSet();

    this.parent().selection.forEach(function(selectable){
        if (selectable && selectable.rotate && selectable.pos) {
            components.add(selectable);
            set.add(selectable.pos());
        }
    });

    var center = set.centroid();

    if(this.parent().selection.size() > 1) {
        center = this.parent().selectedBoundingBox().getCenter();
    }

    components.forEach(function(component){
        component.rotate(angleDegrees, center);
    });
};

